<template>
  <div>
    <div class="full-page" v-if="gridVue">
      <b-icon-x class="close-icon" @click="closePage('gridVue')"></b-icon-x>
      <div class="container-fluid">
        <h3>Grid View</h3>
        <div style="text-align: left; margin-left: 2em; margin-bottom: .25em;">
          <b-button @click="headerModal = true" size="sm">Header Settings</b-button>
          <b-button class="ml-1" @click="customColModal = true" size="sm">Add Custom Column</b-button>
        </div>

        <b-table-simple small striped :sticky-header="tableHeight" :items="flattenedRecords" :fields="currentHeaders">
          <b-thead head-variant="dark">
            <b-tr>
              <b-th class="table-header" :class="headerClass(head)" v-for="head of currentHeaders" :key="head.key" @click="sortTable(head)">{{
                head.label
              }}</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="rec of flattenedRecords" :key="rec.barcode">
              <b-td
                class="cell"
                :style="selectColor(rec, head.key)"
                @dblclick="fetchSeries(rec.externalId, head.key)"
                v-for="head of currentHeaders"
                :key="head.key"
                >{{ rec[head.key] }}</b-td
              >
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>

    <div class="popup" v-if="gridPopup">
      <div class="container-fluid">
        <b-card style="margin: 2em">
          <h3 class="mb-1">{{ selectedElmt }}</h3>
          <p class="mb-0">
            {{
              `${this.currentCell.businessName} - ${this.currentCell.locationName} - ${this.currentCell.plotName} - ${this.currentCell.cropName} - ${
                this.currentCell.varietyName
              }`
            }}
          </p>
          <div class="left-icon-div">
            <b-icon-chevron-left class="left-icon" @click="moveElement('left')"></b-icon-chevron-left>
          </div>
          <div class="right-icon-div">
            <b-icon-x
              class="close-icon"
              style="margin-left: -.2em; margin-top: 1.5em; position: absolute;"
              @click="closePage('gridPopup')"
            ></b-icon-x>
            <b-icon-chevron-right class="left-icon" @click="moveElement('right')"></b-icon-chevron-right>
          </div>

          <svg :width="windowWidth" :height="windowHeight">
            <rect :x="high.x" :y="high.y" :width="high.width" :height="high.height" style="fill:#e6f1fd;stroke-width:1;stroke:#ccc" />
            <rect
              :x="acceptable.x"
              :y="acceptable.y"
              :width="acceptable.width"
              :height="acceptable.height"
              style="fill:#c5e1ff;stroke-width:1;stroke:#ccc"
            />
            <line :x1="perfect.x1" :x2="perfect.x2" :y1="perfect.y1" :y2="perfect.y2" style="stroke:black;stroke-width:3" />

            <g>
              <path class="young" :d="lineGenerator(currentElementData.young)" />
            </g>

            <g>
              <path class="old" :d="lineGenerator(currentElementData.old)" />
            </g>

            <line
              v-if="currentCellxy"
              :x1="currentCellxy.x1"
              :x2="currentCellxy.x2"
              :y1="currentCellxy.y1"
              :y2="currentCellxy.y2"
              style="stroke:#999;stroke-width:2"
              stroke-dasharray="5,5"
            />
            <circle
              v-if="currentCellxy"
              :cx="currentCellxy.circleX"
              :cy="currentCellxy.circleY"
              r="35"
              fill="white"
              style="stroke:#999;stroke-width:2"
              stroke-dasharray="5,5"
            ></circle>

            <circle
              class="point"
              v-for="val in circlexyGenerator.young"
              :key="val.id"
              :cx="val.x"
              :cy="val.y"
              r="5"
              fill="black"
              onmouseover="evt.target.setAttribute('r', '10');"
              onmouseout="evt.target.setAttribute('r', '5');"
            >
              <title>{{ val.value }}</title>
            </circle>
            <text v-for="val in circlexyGenerator.young" :key="val.id2" :x="val.x - 9" :y="val.y - 8">{{ val.value }}</text>

            <circle
              class="point"
              v-for="val in circlexyGenerator.old"
              :key="val.id"
              :cx="val.x"
              :cy="val.y"
              r="5"
              fill="black"
              onmouseover="evt.target.setAttribute('r', '10');"
              onmouseout="evt.target.setAttribute('r', '5');"
            >
              <title>{{ val.value }}</title>
            </circle>
            <text v-for="val in circlexyGenerator.old" :key="val.id2" :x="val.x - 9" :y="val.y - 8">{{ val.value }}</text>

            <d3-axis :scale="getScales.y" position="left" :count="6"></d3-axis>

            <D3OrdinalAxis
              :scale="getScales.x"
              position="bottom"
              :values="dateList"
              :masterTransform="`translate(0, ${windowHeight})`"
              :format="timeFormat"
            ></D3OrdinalAxis>
          </svg>
        </b-card>
      </div>
    </div>

    <b-modal centered ok-only v-model="headerModal" title="Check boxes to show table headers.">
      <b-form-group style="text-align: left">
        <b-form-checkbox-group v-model="displayHeaders" :options="allHeaders.map(x => x.label)"></b-form-checkbox-group>
      </b-form-group>

      <b-form-group style="text-align: left">
        <b-form-checkbox v-model="freezeHeaders" switch>Freeze Headers</b-form-checkbox>
      </b-form-group>
    </b-modal>

    <b-modal centered ok-only v-model="customColModal" title="Create a custom column" hide-footer >
      <b-form @submit.prevent="addCustomCol" style="text-align: left;">
        <b-form-group label="Column Name:" >
          <b-input v-model="form.label"></b-input>
        </b-form-group>
        <b-form-group label="Formula:" description="Formula must be valid JavaScript, i.e. this formula *row['calcium'] / row['magnesium']* calculates Ca to Mg ratio. ">
          <b-input v-model="form.formula"></b-input>
        </b-form-group>
        <b-button type="submit">Submit</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { line, scaleLinear, scaleTime, timeFormat } from "d3";
import { mapActions, mapGetters, mapMutations } from "vuex";
import D3Axis from "../components/D3/D3Axis";
import D3OrdinalAxis from "../components/D3/D3OrdinalAxis";
import { series } from "../modules/api";
import { dynamicSort, dynamicSortDate, dynamicSortNumber, randomId } from "../modules/utils";

export default {
  name: "grid-vue",
  data() {
    return {
      headers: [
        { key: "businessName", label: "Business" },
        { key: "locationName", label: "Location" },
        { key: "plotName", label: "Plot" },
        { key: "cropName", label: "Crop" },
        { key: "varietyName", label: "Variety" },
        { key: "plantPart", label: "Plant Part" },
        { key: "barcode", label: "Barcode" },
        { key: "sampleNumber", label: "Sample Number" },
        { key: "sampleDate", label: "Sample Date" },
        { key: "setName", label: "Set Id" },
      ],
      elements: [
        { key: "sugar", label: "Sugar" },
        { key: "pH", label: "pH" },
        { key: "EC", label: "EC" },
        { key: "potassium", label: "K" },
        { key: "calcium", label: "Ca" },
        // { key: "kcal", label: "K/Ca" },
        { key: "magnesium", label: "Mg" },
        { key: "sodium", label: "Na" },
        { key: "ammonium", label: "NH4" },
        { key: "NO3_nitrate", label: "NO3" },
        { key: "nitrogen_in_nitrate", label: "N-NO3" },
        { key: "nitrogen", label: "N" },
        { key: "chloride", label: "Cl" },
        { key: "sulfur", label: "S" },
        { key: "phosphorous", label: "P" },
        { key: "silica", label: "Si" },
        { key: "iron", label: "Fe" },
        { key: "manganese", label: "Mn" },
        { key: "zinc", label: "Zn" },
        { key: "boron", label: "B" },
        { key: "copper", label: "Cu" },
        { key: "molybdenum", label: "Mo" },
        { key: "aluminium", label: "Al" },
        { key: "cobalt", label: "Co" },
      ],
      customElements: [
        { key: "Ca/K", label: "Ca/K", formula:"row['calcium'] / row['potassium']"},
        { key: "Ca/Mg", label: "Ca/Mg", formula:"row['calcium'] / row['magnesium']"},
        { key: "Ca/B", label: "Ca/B", formula:"row['calcium'] / row['boron']"},
        { key: "Ca/Na", label: "Ca/Na", formula:"row['calcium'] / row['sodium']"},
        { key: "Ca/Al", label: "Ca/Al", formula:"row['calcium'] / row['aluminium']"},
        { key: "P/Zn", label: "P/Zn", formula:"row['phosphorous'] / row['zinc']"},
        { key: "NH4/N", label: "NH4/N", formula:"row['ammonium'] / row['nitrogen']"},
        { key: "Si/B", label: "Si/B", formula:"row['silica'] / row['boron']"},
        { key: "NO3+Cl+K/Ca", label: "NO3+Cl+K/Ca", formula:"(row['NO3_nitrate'] + row['chloride'] + row['potassium']) / row['calcium']"},
        { key: "Mn+Fe/Co", label: "Mn+Fe/Co", formula:"(row['manganese'] + row['iron']) / row['cobalt']"},
      ],
      displayHeaders: [
        "Location",
        "Plot",
        "Set Id",
        "Plant Part",
        "Sample Date",
        "Sugar",
        "pH",
        "EC",
        "K",
        "Ca",
        "Mg",
        "Na",
        "NH4",
        "NO3",
        "N",
        "Cl",
        "S",
        "P",
        "Si",
        "Fe",
        "Mn",
        "Zn",
        "B",
        "Cu",
        "Mo",
        "Al",
        "Co",
      ],
      freezeHeaders: true,
      chartMargin: {
        top: 20,
        bottom: 20,
        right: 31,
        left: 50,
      },
      currentCell: "",
      currentSeries: [],
      selectedElmt: "sugar",
      headerModal: false,
      customColModal: false,
      windowWidth: 0,
      windowHeight: 0,
      flattenedRecords: [],
      lastSorted: "",
      form: {
        label: "",
        formula: "",
      }
    };
  },
  methods: {

    addCustomCol() {
      this.form.key = this.form.label;
      // eslint-disable-next-line no-undef
      this.customElements.push(structuredClone(this.form));
      this.displayHeaders.push(this.form.label);
      this.customColModal = false;
      this.flattenTableData();
    },

    flattenTableData(){
      // eslint-disable-next-line no-undef
      let currentRecords = structuredClone(this.orderedRecords);
      currentRecords = currentRecords.map((x, i) => {
        // delete x.externalId;
        delete x.businessId;
        // delete x.setId;
        delete x.selected;
        let values = {};
        x.values.reverse();
        for (let val of x.values) {
          values[val.name] = parseFloat(val.value);
        }
        delete x.values;
        return { ...x, ...values, i, sampleDate: new Date(x.sampleDate).toLocaleDateString() };
      });

      for (let col of this.customElements) {

        for ( let row of currentRecords) {
          try {
            let value = eval(col.formula);
            if (isNaN(value)) {
              value = "error";
            }
            row[col.label] = value.toFixed(2);
          } catch (err) {
            row[col.label] = "error";
          }
        }
      }
      this.flattenedRecords = currentRecords; 
    },

    async fetchSeries(externalId, header) {
      if (!this.elements.find(x => x.key === header)) {
        return;
      }
      let records = await series.get(externalId);
      if (!records.data.success) {
        return this.notify({
          variant: "error",
          message: records.data.message,
        });
      }
      this.currentSeries = records.data.orders;
      this.selectedElmt = header;
      this.currentCell = records.data.orders.find(x => x.externalId === externalId);
      this.openPage("gridPopup");
    },
    selectColor(record, header) {
      let ranges = this.getRanges.find(x => x.cropName == record.cropName);

      if (!this.elements.map(x => x.key).includes(header)) {
        return {};
      }

      const elmtRange = {};
      if (ranges) {
        for (let name of ranges.names) {
          elmtRange[name] = ranges[name][header];
        }
      }

      let youngVal = record[header];

      const colors = ["#BCFFB3", "gold", "#FFB3B3", "#B3FFFF", "#D9B3FF"];
      let youngColor = colors[0];
      if (youngVal < elmtRange["Ok Low"]) {
        youngColor = colors[1];
      }
      if (youngVal < elmtRange["Very Low"]) {
        youngColor = colors[2];
      }
      if (youngVal > elmtRange["Ok High"]) {
        youngColor = colors[3];
      }
      if (youngVal > elmtRange["Very High"]) {
        youngColor = colors[4];
      }

      return { backgroundColor: youngColor };
    },
    moveElement(direction) {
      let index = this.elements.findIndex(x => x.key == this.selectedElmt);
      if (direction == "left") {
        let i = index - 1;
        if (i < 0) {
          i = this.elements.length - 1;
        }
        this.selectedElmt = this.elements[i].key;
      } else if (direction == "right") {
        let i = index + 1;
        if (i >= this.elements.length) {
          i = 0;
        }
        this.selectedElmt = this.elements[i].key;
      }
    },
    onResize() {
      let hConst = 0.8;
      let wConst = 0.85;

      if (window.innerHeight < 700) {
        hConst = 0.75;
      }

      if (window.innerHeight < 530) {
        hConst = 0.7;
      }

      if (window.innerWidth < 1523) {
        wConst = 0.75;
      }

      if (window.innerWidth < 760) {
        wConst = 0.7;
      }

      this.windowHeight = window.innerHeight * hConst;
      this.windowWidth = window.innerWidth * wConst;
    },
    sortTable(head) {
      this.lastSorted = head.key;
      let records = this.flattenedRecords;
      head.sort = head.sort || 1;
      if (head.numeric) {
        this.flattenedRecords = records.sort(dynamicSortNumber(head.key, head.sort));
      } else {
        this.flattenedRecords = records.sort(dynamicSort(head.key, head.sort));
      }
      head.sort = head.sort >= 1 ? -1 : 1;
    },
    headerClass(head) {
      return {
        desc: head.sort >= 1 && this.lastSorted === head.key,
        asc: head.sort == -1 && this.lastSorted === head.key,
        active: this.lastSorted === head.key,
      };
    },
    ...mapMutations(["closePage", "openPage"]),
    ...mapActions(["notify"]),
  },
  computed: {
    currentHeaders() {
      return this.allHeaders.filter(x => this.displayHeaders.includes(x.label));
    },
    allHeaders() {
      return this.headers.map(x => ({ ...x, numeric: false, sort: null })).concat(this.elements.map(x => ({ ...x, numeric: true, sort: null }))).concat(this.customElements.map(x => ({...x, numeric: true, sort: null})));
    },
    tableHeight() {
      if (!this.freezeHeaders) {
        return false;
      }
      let height = window.innerHeight;
      return `${height - 140}px`;
    },
    currentElementData() {
      let young = this.currentSeries.filter(x => x.plantPart.includes("young"));
      let old = this.currentSeries.filter(x => x.plantPart.includes("old"));

      young = young
        .map(x => ({ value: x.values.find(d => d.name == this.selectedElmt).value, date: new Date(x.sampleDate) }))
        .sort(dynamicSortDate("date"));
      old = old
        .map(x => ({ value: x.values.find(d => d.name == this.selectedElmt).value, date: new Date(x.sampleDate) }))
        .sort(dynamicSortDate("date"));

      return { old, young };
    },
    currentSeriesRange() {
      if (!this.currentSeries[0]) {
        return {};
      }
      const crop = this.currentSeries[0].cropName;
      const ranges = this.getRanges.find(x => x.cropName == crop);
      const elmtRange = {};
      if (ranges) {
        for (let name of ranges.names) {
          elmtRange[name] = ranges[name][this.selectedElmt];
        }
      }
      return elmtRange;
    },
    perfect() {
      const scale = this.getScales;
      const p = this.currentSeriesRange["Perfect"];

      return {
        y1: scale.y(p),
        y2: scale.y(p),
        x1: this.chartMargin.left,
        x2: this.windowWidth - this.chartMargin.right,
      };
    },
    acceptable() {
      const scale = this.getScales;
      const l = this.currentSeriesRange["Ok Low"];
      const h = this.currentSeriesRange["Ok High"];

      return {
        y: scale.y(h),
        x: this.chartMargin.left,
        height: scale.y(l) - scale.y(h),
        width: this.windowWidth - this.chartMargin.right - this.chartMargin.left,
      };
    },
    high() {
      const scale = this.getScales;
      const l = this.currentSeriesRange["Very Low"];
      const h = this.currentSeriesRange["Very High"];

      return {
        y: scale.y(h),
        x: this.chartMargin.left,
        height: scale.y(l) - scale.y(h),
        width: this.windowWidth - this.chartMargin.right - this.chartMargin.left,
      };
    },
    lineGenerator() {
      let scale = this.getScales;
      return line()
        .x((d, i) => scale.x(d.date))
        .y(d => scale.y(parseFloat(d.value)));
      // .curve(d3.curveNatural);
    },
    circlexyGenerator() {
      let scale = this.getScales;
      let xyData = {
        young: [],
        old: [],
      };

      for (let row of this.currentElementData.young) {
        xyData.young.push({ x: scale.x(row.date), y: scale.y(row.value), value: row.value, id: randomId(), id2: randomId() });
      }

      for (let row of this.currentElementData.old) {
        xyData.old.push({ x: scale.x(row.date), y: scale.y(row.value), value: row.value, id: randomId(), id2: randomId() });
      }

      return xyData;
    },
    currentCellxy() {
      if (!this.currentCell) {
        return false;
      }

      let value = this.currentCell.values.find(x => x.name === this.selectedElmt);
      if (!value) {
        return false;
      }

      let scale = this.getScales;

      let circleX = scale.x(new Date(this.currentCell.sampleDate));
      let circleY = scale.y(value.value);

      let y1 = this.windowHeight - this.chartMargin.top - this.chartMargin.bottom;

      return { circleX, circleY, y1, y2: this.chartMargin.top, x1: circleX, x2: circleX };
    },
    dateList() {
      let data = this.currentElementData.old.concat(this.currentElementData.young);
      return data.map(x => x.date);
    },
    getScales() {
      const range = this.currentSeriesRange;

      let data = this.currentElementData.old.concat(this.currentElementData.young);
      const dates = this.dateList;

      // const x = d3.scaleOrdinal().domain( dates ).range( indices );
      const x = scaleTime()
        .domain([Math.min(...dates), Math.max(...dates)])
        .range([this.chartMargin.left, this.windowWidth - this.chartMargin.right]);
      let values = data.map(x => x.value);

      if (range["Very Low"] && range["Very High"]) {
        values = values.concat([range["Very Low"], range["Very High"]]);
      }

      const y = scaleLinear()
        .domain([Math.max(...values), Math.min(...values)])
        .range([this.chartMargin.top, this.windowHeight - this.chartMargin.top - this.chartMargin.bottom]);
      return { x, y };
    },
    timeFormat() {
      return timeFormat("%m/%d/%Y");
    },
    ...mapGetters({
      searchResults: "currentSearchResults",
      addresses: "currentAddresses",
      currentRecords: "currentRecordList",
      gridVue: "gridVue",
      gridPopup: "gridPopup",
      getRanges: "getRanges",
      orderedRecords: "orderedRecords",
      setIds: "currentSetIds",
    }),
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  watch: {
    gridVue(newVal) {
      if (newVal) {
        this.flattenTableData();
      }
    },
  },
  components: {
    D3Axis,
    D3OrdinalAxis,
  },
};
</script>

<style lang="scss" scoped>
.popup {
  width: 100%;
  height: 100%;
  top: 0;
  position: fixed;
  z-index: 1200;
  padding: 1em;
  background-color: rgba(0, 0, 0, 0.568);
}

.point {
  cursor: pointer;
  &:hover {
    fill: lightblue;
  }
}

.young {
  fill: none;
  stroke: lightgreen;
  stroke-width: 4px;
}

.old {
  fill: none;
  stroke: darkgreen;
  stroke-width: 4px;
}

.left-icon {
  position: absolute;
  font-size: 2.75em;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.left-icon-div {
  position: fixed;
  left: 5em;
  top: 0;
  height: 100%;
}

.right-icon-div {
  position: fixed;
  right: 6.8em;
  top: 0;
  height: 100%;
}

.active {
  background-color: rgb(105, 105, 105) !important;
}

.table-header {
  cursor: pointer;
}

.table-header:after {
  content: " ";
  position: absolute;
  text-align: center;
  bottom: 0px;
  left: 50%;
  transform: translate(-50%, -50%);
}

.asc:after {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 0px solid transparent;
  border-bottom: 5px solid rgb(255, 255, 255);
}

.desc:after {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid rgb(255, 255, 255);
}
</style>
